// Func = limiting Scope for this file
var lastScrollTop = 0

/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
var scrollParallax = []
var scrolled = 0

// screen height
var v_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight

function doParallax(elm) {
	let boundes = elm.dataset.parallax.split(',') // get it from html
	//get distance in positive value
	let distance = Math.abs(boundes[0] - boundes[1])
	if (boundes[0] > boundes[1]) {
		//get distance in negative value (to do the scroll inverse)
		distance = distance * -1
	}
	//Equivalent distance using screen height + element height
	const unit_scroll = distance / (v_height + elm.offsetHeight)
	let temp = 0

	let topElement = 0
	let element = elm

	let id_elem = elm.dataset.parallaxid

	do {
		topElement += element.offsetTop || 0
		element = element.offsetParent
	} while (element)

	let parallaxFunction = function () {
		//Obtain the distance between top screen and document top 0
		scrolled = document.documentElement.scrollTop || window.pageYOffset
		//Distance of bottom page to top of the element
		let relative_distance = scrolled + v_height - topElement
		//transpoling data to move the parallax element relative to the scroll of all the screen
		temp = unit_scroll * relative_distance + parseInt(boundes[0])
		//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
		elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
	}

	scrollParallax[id_elem] = parallaxFunction

	window.addEventListener('scroll', scrollParallax[id_elem])
}

let observers_parallax = document.querySelectorAll('.js-parallax-element')

if (observers_parallax) {
	let options_parallax = {
		root: null, // relative to document viewport
		rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
		threshold: 0, // visible amount of item shown in relation to root
	}

	function handler_parallax(entries, observer) {
		let entry
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				doParallax(entry.target)
			} else {
				let id_elem = entry.target.dataset.parallaxid
				window.removeEventListener('scroll', scrollParallax[id_elem])
			}
		})
	}

	let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
	let counter = 1
	observers_parallax.forEach(function (element) {
		observable_parallax.observe(element)
		element.dataset.parallaxid = counter
		counter++
	})
}

;(function () {
	$(document).ready(function () {
		var svgContainer = document.getElementById('logoDefault')
		var animItem = lottie.loadAnimation({
			wrapper: svgContainer,
			animType: 'svg',
			loop: false,
			path: 'logo.json',
		})

		//Call function with browser is resized.
		$(window).resize(function (event) {
			// resizeWindow();
		})
		// resizeWindow();

		// Main Nav Dropdown
		if (window.screen.width >= 1024) {
			$('#primary-nav li').hover(
				function () {
					$(this).addClass('hover')
					$('ul.submenu', this).fadeIn(200)
					$('ul.submenu', this).addClass('hover-submenu')
				},
				function () {
					$(this).removeClass('hover')
					$('ul.submenu', this).fadeOut(200)
					$('ul.submenu', this).removeClass('hover-submenu')
				},
			)
		}

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true]
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val())
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val())
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top'
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight'
			} else {
				DATE_STYLE[1] = ''
			}
			return DATE_STYLE
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd'
		$('#CheckIn').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				newDate.setDate(newDate.getDate() + 3)
				$('#CheckOut').datepicker('setDate', newDate)
				$('#CheckOut').datepicker('option', 'minDate', selectedDate)
			},
		})
		$('#CheckOut').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		})

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	})

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})

		// document.querySelector('.btn-menu').addEventListener('click' , ()=>{
		// 	document.querySelector('.primary-nav-container').classList.add('open');
		// })
		// if(document.querySelector('#js-btn-menu')){
		// 	document.querySelector('#js-btn-menu').addEventListener('click' , ()=>{
		// 		document.querySelector('.primary-nav-container').classList.add('open');
		// 	})
		// }

		// document.querySelector('.close-menu').addEventListener('click' , ()=>{
		// 	document.querySelector('.primary-nav-container').classList.remove('open');
		// })

		if (window.screen.width <= 600) {
			let allmainNav = document.getElementById('primary-nav').getElementsByTagName('a')
			let allmainLength = allmainNav.length
			let oldNode = null
			for (let i = 0; i < allmainLength; i++) {
				allmainNav[i].addEventListener('click', function (e) {
					if (window.screen.width <= 1024) {
						if (this.nextElementSibling !== null) {
							e.preventDefault()

							if (!this.nextElementSibling.classList.contains('open-item')) {
								if (oldNode) {
									oldNode.nextElementSibling.classList.remove('open-item')
								}
								this.nextElementSibling.classList.add('open-item')
							} else {
								this.nextElementSibling.classList.remove('open-item')
							}

							oldNode = this
						}
					}
				})
			}
		}
	}
})()

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up')
			document.getElementById('header').classList.remove('down')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
}

//OBSERVER

let targetsElments = document.querySelectorAll('.animate-bg')

let options = {
	rootMargin: '-100px',
	threshold: 0.35,
}

let observer = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('transition')
		} else {
			entry.target.classList.remove('transition')
		}
	})
}, options)

targetsElments.forEach((target) => {
	observer.observe(target)
})

// Hover js submenu
if (document.querySelectorAll('.submenu.privary-navigation__submenu')) {
	document.querySelectorAll('.submenu.privary-navigation__submenu').forEach((elm) => {
		elm.addEventListener('mouseover', function () {
			this.previousElementSibling.style.fontWeight = '900'
		})

		elm.addEventListener('mouseleave', function () {
			this.previousElementSibling.style.fontWeight = '400'
		})
	})
}

//Loading preload
// if (document.getElementById('home')) {
// 	document.onreadystatechange = function () {
// 		if (document.readyState === 'complete') {
// 			setTimeout(function () {
// 				console.log(document.readyState)
// 				document.documentElement.scrollTop = 0
// 				document.getElementById('preloader-home').classList.add('hide')
// 				document.getElementById('preloader-overlay').classList.add('hide')
// 				document.getElementById('fake-content').classList.add('hide')

// 				document.querySelector('.video-home').play()
// 			}, 5000)
// 		}
// 	}
// }

//Play and stop video home

const btnVideo = document.getElementById('btn_playvideo')
const videoAsset = document.querySelector('.video-home')

if (btnVideo) {
	btnVideo.addEventListener('click', () => {
		if (videoAsset.paused) {
			videoAsset.play()
			document.getElementById('btn_playvideo').children[0].classList.add('hidden')
			document.getElementById('btn_playvideo').children[1].classList.remove('hidden')
		} else {
			videoAsset.pause()
			document.getElementById('btn_playvideo').children[0].classList.remove('hidden')
			document.getElementById('btn_playvideo').children[1].classList.add('hidden')
		}
	})

	btnVideo.addEventListener('mouseover', () => {
		if (videoAsset.paused) {
			document.getElementById('btn_playvideo').children[0].classList.add('hidden')
			document.getElementById('btn_playvideo').children[1].classList.remove('hidden')
		}
	})

	btnVideo.addEventListener('mouseleave', () => {
		if (videoAsset.paused) {
			document.getElementById('btn_playvideo').children[0].classList.remove('hidden')
			document.getElementById('btn_playvideo').children[1].classList.add('hidden')
		}
	})
}

window.addEventListener('load', function () {
	let input = document.querySelector('.ot-button.ot-dtp-picker-button')
	let form = document.querySelector('.ot-dtp-picker-form')

	if (input !== null && form !== null) {
		let input_container = document.createElement('div')
		input_container.classList.add('submit-container')
		input_container.appendChild(input)

		form.appendChild(input_container)
	}
})


/* Timeline Quad Functionality */
document.querySelectorAll(".timeline").forEach((timelineBlock, index) => {
    let timelineTabs = timelineBlock.querySelectorAll(".timeline__lineTabs li");
    let currentIndex = 0; 

    function activateTab(indexToActivate) {
        let currentTab = timelineTabs[indexToActivate];
        let currentRef = currentTab.getAttribute("data-ref");

        timelineTabs.forEach(tab => tab.classList.remove('active'));
        timelineBlock.querySelectorAll(".timeline__item").forEach(item => item.classList.remove('active'));

  
        timelineTabs[indexToActivate].classList.add('active');
        timelineBlock.querySelectorAll(`[data-ref="${currentRef}"]`).forEach(el => {
            el.classList.add('active');
        });

        currentIndex = indexToActivate;
    }

  
    timelineTabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => {
            activateTab(idx);
            resetAutoRotate(); 
        });
    });

  
    function autoRotateTabs() {
        currentIndex = (currentIndex + 1) % timelineTabs.length;
        activateTab(currentIndex);
    }

    let autoRotateInterval = setInterval(autoRotateTabs, 5000);

    function resetAutoRotate() {
        clearInterval(autoRotateInterval);
        autoRotateInterval = setInterval(autoRotateTabs, 5000);
    }

    activateTab(0);
});


/* END */

